import { render, staticRenderFns } from "./LandedCostSettings.vue?vue&type=template&id=c28eed0c&scoped=true"
import script from "./LandedCostSettings.vue?vue&type=script&lang=ts"
export * from "./LandedCostSettings.vue?vue&type=script&lang=ts"
import style0 from "./LandedCostSettings.vue?vue&type=style&index=0&id=c28eed0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28eed0c",
  null
  
)

export default component.exports